export default __webpack_public_path__ + "static/media/parallel.19826404.jpg";